import styled from 'styled-components';

export const SHint = styled.div`
    margin-top: 5px;
    font-size: 1.2rem;
    font-weight: 500;
    color: ${({ theme }) => theme.color.text.light};
`;
